/**
 * Dlaždica Unmatched v knižnici portálu. Portál o hre nič nevie — obsah
 * dodáva hra sama (viď `games/registry.ts`), rám karty je portálový `GameCard`.
 */

import { IMPLEMENTED_HEROES } from '@unmatched/engine';
import { useEffect, useState } from 'react';

import { GameCard } from '../../portal/GameCard.js';
import type { PortalTileProps } from '../registry.js';
import { matches, type MatchSummary } from './api.js';
import { heroName } from './screens/Home.js';

export function UnmatchedTile({ navigate }: PortalTileProps) {
  const [list, setList] = useState<MatchSummary[] | null>(null);

  useEffect(() => {
    void matches
      .list()
      .then((result) => setList(result.matches))
      .catch(() => setList([]));
  }, []);

  const open = (list ?? []).filter((m) => m.status === 'playing' || m.status === 'lobby');
  const myTurn = open.filter((m) => m.your_move).length;

  return (
    <GameCard
      title="Unmatched"
      status="live"
      badge="Plná verzia 1.0"
      // Písmo loga Unmatched (Syne) — rovnaké ako v hre.
      titleStyle={{ fontFamily: "'Syne', 'Arial Black', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em' }}
      players="2–4 hráči"
      duration="20–40 min"
      tags={['Súboj', 'Karty', 'Aj proti botovi']}
      description={`Taktický súboj legendárnych hrdinov — karty, pohyb po doske a súčasné odhalenie v súboji. ${IMPLEMENTED_HEROES.length} hrateľných postáv.`}
      onPlay={() => navigate('#/unmatched')}
      cover={
        <span className="libCover libCover--unmatched">
          <img className="libCover__brand" src="/art/unmatched/logo.webp" alt="Unmatched" draggable={false} />
        </span>
      }
    >
      {open.length ? (
        <div className="libGame__tables">
          <span className="libGame__tablesHead">
            Tvoje stoly · {open.length}
            {myTurn ? <b> · na ťahu si v {myTurn}</b> : null}
          </span>
          {open.slice(0, 3).map((match) => (
            <button
              key={match.id}
              type="button"
              className={`libGame__table${match.your_move ? ' is-turn' : ''}`}
              onClick={() => navigate(`#/unmatched/g/${match.id}`)}
            >
              <span>{match.heroes.map((h) => (h ? heroName(h) : '?')).join(' vs ')}</span>
              <small>
                {match.status === 'lobby' ? 'čaká na súpera' : match.your_move ? 'si na ťahu' : 'ťahá súper'} →
              </small>
            </button>
          ))}
        </div>
      ) : null}
    </GameCard>
  );
}
